function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.84 3.195h146.48V109H1.84Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.27 3.195h113.46c9.075 0 16.43 7.352 16.43 16.426v72.762c0 9.07-7.355 16.426-16.43 16.426H18.27c-9.075 0-16.43-7.356-16.43-16.426V19.62c0-9.074 7.355-16.426 16.43-16.426"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.844 3.195H148.19v105.282H1.844Zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.273 3.195h113.485c9.074 0 16.43 7.332 16.43 16.375v72.532c0 9.043-7.356 16.375-16.43 16.375H18.273c-9.074 0-16.43-7.332-16.43-16.375V19.57c0-9.043 7.356-16.375 16.43-16.375"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "e"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46 13.059h93V74H46Zm0 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1.84 3.195h146.48v105.528H1.84Zm0 0"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#c)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#d)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#131313",
  strokeWidth: 8,
  d: "M21.998.002h151.948c12.15 0 21.999 9.85 21.999 21.998v97.44c0 12.148-9.849 21.998-21.999 21.998H21.998c-12.15 0-21.999-9.85-21.999-21.998V22C0 9.852 9.848.002 21.998.002",
  transform: "matrix(.74686 0 0 .74437 1.844 3.194)"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#e)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4caf50",
  d: "M48.996 12.844H136a2.71 2.71 0 0 1 2.512 1.687c.136.336.207.688.207 1.051v54.723c0 .363-.07.715-.207 1.047a2.727 2.727 0 0 1-1.473 1.484 2.71 2.71 0 0 1-1.039.207H48.996a2.73 2.73 0 0 1-1.043-.207 2.812 2.812 0 0 1-.883-.594 2.716 2.716 0 0 1-.586-.89 2.663 2.663 0 0 1-.207-1.047V15.582a2.741 2.741 0 0 1 .793-1.938c.258-.253.551-.453.883-.593a2.73 2.73 0 0 1 1.043-.207Zm0 0"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffe082",
  d: "M103.371 78.61H86.848l-12.23.968a8.123 8.123 0 0 1-3.458-.254 8.024 8.024 0 0 1-1.605-.672 8.206 8.206 0 0 1-2.621-2.281 8.314 8.314 0 0 1-1.625-4.914c-.004-1.937.558-3.687 1.695-5.25l8.555-11.832a8.98 8.98 0 0 0 .777-1.473 8.947 8.947 0 0 0 .5-1.59 9.176 9.176 0 0 0 .105-3.32 9.237 9.237 0 0 0-.402-1.617 9.134 9.134 0 0 0-.684-1.52 8.864 8.864 0 0 0-.949-1.363 9.027 9.027 0 0 0-10.555-2.473 9 9 0 0 0-2.73 1.863L47.836 56.75a20.069 20.069 0 0 0-10.02 3.32 20.12 20.12 0 0 0-4.023 3.504 20.362 20.362 0 0 0-2.973 4.446 2.937 2.937 0 0 0-.195.546l-6.008 22.93a2.722 2.722 0 0 0-.055 1.137 2.712 2.712 0 0 0 2.266 2.266l35.016 5.402a21.85 21.85 0 0 0 5.379.508 28.964 28.964 0 0 0 8.285-.692 29.063 29.063 0 0 0 7.765-2.996l21.536-13.45a2.762 2.762 0 0 0 1.285-2.202 2.872 2.872 0 0 0-.102-.875 2.757 2.757 0 0 0-.98-1.434 2.678 2.678 0 0 0-1.64-.55Zm0 0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#546e7a",
  d: "M10.93 100.5c-.36 0-.707-.07-1.04-.21a2.607 2.607 0 0 1-.882-.595 2.749 2.749 0 0 1-.797-1.934V59.454c0-.797.293-1.465.875-2.008.578-.55 1.262-.789 2.055-.715 3.074.239 18.648 1.672 23.382 6.215.309.282.54.617.692 1.008.152.387.215.793.183 1.207a144.94 144.94 0 0 1-5.566 27.961 2.65 2.65 0 0 1-1.238 1.543A44.235 44.235 0 0 1 10.93 100.5Zm0 0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M92.496 56.625c-7.312 0-13.016-3.164-13.566-7.52a2.75 2.75 0 0 1 .55-2.027 2.76 2.76 0 0 1 1.813-1.039c.36-.043.715-.02 1.062.078.348.094.668.254.954.477a2.777 2.777 0 0 1 1.03 1.828c.099.793 3.083 2.734 8.157 2.734 5.27 0 8.156-2.05 8.156-2.734 0 0-.09-1.715-7.937-2.688l-.578-.078c-3.989-.492-13.235-1.636-13.235-8.187 0-4.676 5.844-8.207 13.594-8.207 7.317 0 13.02 3.156 13.567 7.515a2.731 2.731 0 0 1-.551 2.024 2.76 2.76 0 0 1-1.813 1.039 2.713 2.713 0 0 1-2.011-.559 2.76 2.76 0 0 1-.7-.804 2.833 2.833 0 0 1-.336-1.016c-.082-.637-2.78-2.738-8.156-2.738-5.27 0-8.156 2.054-8.156 2.738 0 0 .094 1.719 7.965 2.687l.547.07c3.98.497 13.218 1.641 13.218 8.208.02 4.668-5.824 8.199-13.574 8.199Zm0 0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M92.496 62.098a2.71 2.71 0 0 1-2.512-1.692 2.734 2.734 0 0 1-.207-1.047V26.527a2.752 2.752 0 0 1 .797-1.938 2.71 2.71 0 0 1 4.434.887c.14.337.207.688.207 1.051V59.36c0 .364-.067.715-.207 1.047a2.751 2.751 0 0 1-1.469 1.484 2.73 2.73 0 0 1-1.043.208ZM125.125 29.262H114.25a2.715 2.715 0 0 1-1.926-.801 2.817 2.817 0 0 1-.59-.887 2.763 2.763 0 0 1 0-2.097c.141-.332.336-.63.59-.887.258-.254.551-.453.883-.594.332-.137.68-.207 1.043-.207h10.875a2.71 2.71 0 0 1 2.512 1.688 2.768 2.768 0 0 1 0 2.097c-.14.332-.336.63-.59.887a2.705 2.705 0 0 1-1.922.8Zm0 0"
});

function SvgCashPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 112.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashPayment);
export default __webpack_public_path__ + "static/media/cash-payment.337b6d40.svg";
export { ForwardRef as ReactComponent };